import { useMemo } from 'react';
import { useHandlers } from '../../../context/page-context';
import type { ThemeEditorApiContract } from '../api/editor.api';

export function useThemeEditorApi(): { themeEditorApi: ThemeEditorApiContract } {
  const { apis } = useHandlers();
  // `editor()` is a factory; memoize on the stable api so consumers get a stable ref.
  const themeEditorApi = useMemo(() => apis.themes.editor(), [apis.themes]);
  return { themeEditorApi };
}
